<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation="0">
						<v-toolbar flat class="border_bottom" shaped>
							<v-btn icon @click="goBack">
								<v-icon>mdi-arrow-left</v-icon>
							</v-btn>
							<v-toolbar-title>Affiliate Dashboard - Fatture {{ partnerName }}</v-toolbar-title>
						</v-toolbar>

						<v-data-table
							:headers="headers"
							:items="invoices"
							:options.sync="settings.options"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="affiliate-invoice-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.code || '-'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-chip small class="mr-1" :color="item.active ? 'success' : 'warning'" :dark="item.active">
														{{ item.active ? 'Pagato' : 'In attesa' }}
													</v-chip>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon v-bind="attrs" v-on="on" color="primary" small>
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="openConfirm('paid', item)">
																<v-list-item-title class="size9">Pagato</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="openConfirm('delete', item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense>
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="openConfirm('paid', item)">
														<v-list-item-title class="size9">Pagato</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="openConfirm('delete', item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>{{ item.code || '-' }}</td>
										<td>{{ item.from | moment('DD/MM/YYYY') }}</td>
										<td>{{ item.to | moment('DD/MM/YYYY') }}</td>
										<td>{{ formatAmount(item.commission) }}</td>
										<td>
											<v-chip small :color="item.active ? 'success' : 'warning'" :dark="item.active">
												{{ item.active ? 'Pagato' : 'In attesa' }}
											</v-chip>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="360">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>{{ confirmText }}</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>
					<v-btn color="primary" text @click="confirmAction"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
			<span v-html="snackbar.text"></span>
			<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
import { listReturnLocation } from '@/components/core/list/listReturn';
import { mapActions, mapGetters } from 'vuex';
import KeyValueCard from '@/components/core/KeyValueCard.vue';

export default {
	name: 'AffiliateDashboardInvoices',
	components: {
		KeyValueCard,
	},
	data() {
		return {
			dialogconfirm: false,
			selectedAction: '',
			selectedInvoice: null,
			listSize: [15, 25, 50, 100],
			settings: {
				options: {
					sortBy: ['from'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			headers: [
				{ text: '', value: 'actions', sortable: false },
				{ text: 'Codice', value: 'code', sortable: true },
				{ text: 'From', value: 'from', sortable: true },
				{ text: 'To', value: 'to', sortable: true },
				{ text: 'Commission', value: 'commission', sortable: true },
				{ text: 'Status', value: 'active', sortable: true },
			],
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		...mapGetters({
			getItem: 'partners/getItem',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		partnerName() {
			const name = [this.getItem?.name, this.getItem?.lastname].filter(Boolean).join(' ');
			return name || '';
		},
		invoices() {
			return Array.isArray(this.getItem?.invoices) ? this.getItem.invoices : [];
		},
		confirmText() {
			if (this.selectedAction === 'paid') {
				return 'Confermando la fattura verra segnata come pagata.';
			}
			if (this.selectedAction === 'delete') {
				return 'Confermando la fattura verra eliminata e gli ordini nel suo intervallo date torneranno in attesa.';
			}
			return '';
		},
	},
	async created() {
		await this.getDataFromApi();
	},
	methods: {
		...mapActions({
			fetchPartnerDetail: 'partners/getDetail',
			markInvoicePaid: 'partners/markInvoicePaid',
			deleteInvoice: 'partners/deleteInvoice',
		}),
		async getDataFromApi() {
			if (!this.$route.params.id) {
				return;
			}

			const result = await this.fetchPartnerDetail({ _id: this.$route.params.id });
			if (!result) {
				this.showMessage('error', 'Errore durante il caricamento del partner', 4000);
			}
		},
		openConfirm(action, item) {
			if (!item?._id) {
				return;
			}
			this.selectedAction = action;
			this.selectedInvoice = item;
			this.dialogconfirm = true;
		},
		async confirmAction() {
			if (!this.selectedInvoice?._id || !this.selectedAction) {
				this.dialogconfirm = false;
				return;
			}

			try {
				const payload = {
					partner_id: this.$route.params.id,
					invoice_id: this.selectedInvoice._id,
				};

				if (this.selectedAction === 'paid') {
					await this.markInvoicePaid(payload);
					this.showMessage('success', 'Fattura segnata come pagata', 3000);
				}
				if (this.selectedAction === 'delete') {
					await this.deleteInvoice(payload);
					this.showMessage('success', 'Fattura eliminata con successo', 3000);
				}

				this.dialogconfirm = false;
				this.selectedAction = '';
				this.selectedInvoice = null;
				await this.getDataFromApi();
			} catch (e) {
				this.showMessage('error', 'Errore durante aggiornamento fattura', 4000);
			}
		},
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			const data = v => (v ? this.$moment(v).format('DD/MM/YYYY') : '');
			return [
				{ label: 'From', value: data(item.from) },
				{ label: 'To', value: data(item.to) },
				{ label: 'Commission', value: this.formatAmount(item.commission), strong: true },
			];
		},
		formatAmount(value) {
			return Number(value || 0).toFixed(2);
		},
		showMessage(color, text, timeout) {
			this.snackbar.color = color;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = timeout;
		},
		// torna alla dashboard nello stato in cui era (periodo, pagina, ricerca)
		goBack() {
			this.$router.push(listReturnLocation('/affiliate/dashboard')).catch(() => {});
		},
	},
	beforeDestroy() {
		this.$store.dispatch('partners/destroyData');
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.affiliate-invoice-cards,
.affiliate-invoice-cards tr {
	display: block;
	width: 100%;
}
.affiliate-invoice-cards tr,
.affiliate-invoice-cards tr:hover {
	background: transparent !important;
}
.affiliate-invoice-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.affiliate-invoice-cards tr:first-child td {
	padding-top: 12px !important;
}
.affiliate-invoice-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.affiliate-invoice-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
